export default __webpack_public_path__ + "static/media/brisket-making.76c2aa3e.png";